var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("h1", { staticClass: "text-center bot-blue" }, [
        _vm._v("Chỉnh sửa thông tin ảnh"),
      ]),
      _c(
        "bot-spinner",
        {
          model: {
            value: _vm.spinner,
            callback: function ($$v) {
              _vm.spinner = $$v
            },
            expression: "spinner",
          },
        },
        [
          _c("v-file-input", {
            attrs: {
              placeholder: "Upload files",
              label: "Upload files",
              accept: "image/png, image/jpeg",
              "show-size": "",
              multiple: "",
            },
            model: {
              value: _vm.values.files,
              callback: function ($$v) {
                _vm.$set(_vm.values, "files", $$v)
              },
              expression: "values.files",
            },
          }),
          _c(
            "fieldset",
            { staticClass: "fieldset-table" },
            [
              _c("v-form", {
                ref: "form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submit.apply(null, arguments)
                  },
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.submit.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.isValid,
                  callback: function ($$v) {
                    _vm.isValid = $$v
                  },
                  expression: "isValid",
                },
              }),
              _c(
                "legend",
                [
                  _c("v-checkbox", {
                    attrs: { label: "resize", color: "success" },
                    model: {
                      value: _vm.values.resize,
                      callback: function ($$v) {
                        _vm.$set(_vm.values, "resize", $$v)
                      },
                      expression: "values.resize",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        attrs: {
                          autofocus: "",
                          label: "Tiêu đề bài viết",
                          rules: [
                            (val) =>
                              _vm.vld.text({
                                field: "tiêu đề bài viết",
                                value: val,
                              }),
                          ],
                        },
                        model: {
                          value: _vm.values.XPSubject,
                          callback: function ($$v) {
                            _vm.$set(_vm.values, "XPSubject", $$v)
                          },
                          expression: "values.XPSubject",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c("metadata-logo", {
                        ref: "mlogo",
                        on: { onChange: _vm.onLogoChange },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "vĩ độ",
                          rules: [
                            (val) =>
                              _vm.vld.text({
                                field: "vĩ độ",
                                value: val,
                              }),
                          ],
                        },
                        model: {
                          value: _vm.values.latitudeDegrees,
                          callback: function ($$v) {
                            _vm.$set(_vm.values, "latitudeDegrees", $$v)
                          },
                          expression: "values.latitudeDegrees",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "kinh độ",
                          rules: [
                            (val) =>
                              _vm.vld.text({
                                field: "kinh độ",
                                value: val,
                              }),
                          ],
                        },
                        model: {
                          value: _vm.values.longitudeDegrees,
                          callback: function ($$v) {
                            _vm.$set(_vm.values, "longitudeDegrees", $$v)
                          },
                          expression: "values.longitudeDegrees",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    _vm._b({}, "v-col", _vm.columns, false),
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Tác quyền công ty",
                          rules: [
                            (val) =>
                              _vm.vld.text({
                                field: "tác quyền",
                                value: val,
                              }),
                          ],
                        },
                        model: {
                          value: _vm.values.Copyright,
                          callback: function ($$v) {
                            _vm.$set(_vm.values, "Copyright", $$v)
                          },
                          expression: "values.Copyright",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    _vm._b({}, "v-col", _vm.columns, false),
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Comments",
                          rules: [
                            (val) =>
                              _vm.vld.text({
                                field: "Comments",
                                value: val,
                              }),
                          ],
                        },
                        model: {
                          value: _vm.values.XPComment,
                          callback: function ($$v) {
                            _vm.$set(_vm.values, "XPComment", $$v)
                          },
                          expression: "values.XPComment",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    _vm._b({}, "v-col", _vm.columns, false),
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Tác giả sáng tác",
                          rules: [
                            (val) =>
                              _vm.vld.text({
                                field: "tác giả",
                                value: val,
                              }),
                          ],
                        },
                        model: {
                          value: _vm.values.XPAuthor,
                          callback: function ($$v) {
                            _vm.$set(_vm.values, "XPAuthor", $$v)
                          },
                          expression: "values.XPAuthor",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    _vm._b({}, "v-col", _vm.columns, false),
                    [
                      _c("v-combobox", {
                        attrs: {
                          chips: "",
                          clearable: "",
                          label: "Từ khóa",
                          "append-icon": "",
                          multiple: "",
                          solo: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function ({
                              attrs,
                              item: chip,
                              select,
                              selected: slt,
                            }) {
                              return [
                                _c(
                                  "v-chip",
                                  _vm._b(
                                    {
                                      attrs: { "input-value": slt, close: "" },
                                      on: {
                                        click: select,
                                        "click:close": function ($event) {
                                          return _vm.removeKeyword(chip)
                                        },
                                      },
                                    },
                                    "v-chip",
                                    attrs,
                                    false
                                  ),
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(chip) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.values.XPKeywords,
                          callback: function ($$v) {
                            _vm.$set(_vm.values, "XPKeywords", $$v)
                          },
                          expression: "values.XPKeywords",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { color: "primary" },
                  on: { click: _vm.submit },
                },
                [
                  _vm._v("\n                Xác nhận\n                "),
                  _c("v-icon", { attrs: { right: "" } }, [
                    _vm._v(" mdi-check "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/tool/file/tool.file.metadata.vue